export default "__VITE_ASSET__fef49ee9__"